import { Input } from '@alifd/next';
import { getStructureFieldName } from '../utils';
import { useComponentContext } from '../../context/useComponentContext';
const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
const ProInput = (props) => {
    const { screen_structure, screen_structure_field, screen_inner_id, disableEdit, ...otherProps } = props;
    const { structureName, structureField } = getStructureFieldName(screen_structure, screen_structure_field);
    const fieldPath = `${structureName}.${structureField}`;
    const { value, onValueChange } = useComponentContext(fieldPath);
    console.log('ProInput useComponentContext value', value, fieldPath);
    const handleChange = (newValue) => {
        if (onValueChange) {
            onValueChange(newValue);
        }
        if (props.onChange) {
            props.onChange(newValue, structureName, structureField);
        }
    };
    return (createElement("span", { className: `field-wrapper ${disableEdit ? 'disable-edit' : 'enable-edit'}` },
        createElement(Input, { ...props, value: value, onChange: handleChange })));
};
export default ProInput;
